import BigNumber from 'bignumber.js'
import erc20ABI from 'config/abi/erc20.json'
import darkVaultABI from 'config/abi/darkvault.json'
import dmdVaultABI from 'config/abi/dmdvault.json'
import multicall, { multicallWithAbi } from 'utils/multicall'
import { getAddress } from 'utils/addressHelpers'
import { VaultConfig } from 'config/constants/types'

export const fetchVaultUserAllowances = async (account: string, vaultsToFetch: VaultConfig[]) => {

  const calls = vaultsToFetch.map((vault) => {
    const contractAddress = getAddress(vault.contractAddress)
    const tokenAddress = getAddress(vault.token.address)
    return { address: tokenAddress, name: 'allowance', params: [account, contractAddress] }
  })
  const rawAllowances = await multicall(erc20ABI, calls)
  const parsedAllowances = rawAllowances.map((balance) => {
    return new BigNumber(balance).toJSON()
  })
  return parsedAllowances
}

export const fetchVaultUserTokenBalances = async (account: string, vaultsToFetch: VaultConfig[]) => {
  const calls = vaultsToFetch.map((vault) => {
    const tokenAddress = getAddress(vault.token.address)
    return {
      address: tokenAddress,
      name: 'balanceOf',
      params: [account],
    }
  })

  const rawTokenBalances = await multicall(erc20ABI, calls)
  const parsedTokenBalances = rawTokenBalances.map((tokenBalance) => {
    return new BigNumber(tokenBalance).toJSON()
  })
  return parsedTokenBalances
}

export const fetchVaultUserSharesBalances = async (account: string, vaultsToFetch: VaultConfig[]) => {

  const calls = vaultsToFetch.map((vault) => {
    return {
      address: getAddress(vault.contractAddress),
      name: vault.name === 'DMD' ? 'userInfo' : 'balanceOf',
      params: [account],
      abi: vault.name === 'DMD' ? dmdVaultABI : darkVaultABI,
    }
  })
  const darkSharesBalances = await multicallWithAbi(calls)

  const parsedSharesBalances = vaultsToFetch.map((vault, index) => {
    switch (vault.name) {
      case 'DMD':
        return `${new BigNumber(darkSharesBalances[index].shares._hex).toJSON()}/${new BigNumber(darkSharesBalances[index].lastDepositedTime._hex).toJSON()}`
      default:
        return new BigNumber(darkSharesBalances[index][0]._hex).toJSON()
    }
  })
  return parsedSharesBalances
}
